module.exports = __webpack_public_path__ + "img/login-logo.4d74e3ee.png";